import React, { Component } from "react";
import { Field } from "redux-form";
import { Header, Label, Form } from "semantic-ui-react";
import { MandatoryHeader, tooltips } from "./formUtils";
import { getUserType } from "../../app/common/util/genericUtils";
import { Tooltip, Col, Icon } from "antd";
import { connect } from "react-redux";
import {
  setCustomerDependencies,
  setInitialManufacturingLocation,
} from "./orderActions";
import { withRouter } from "react-router-dom";
import { ORDER_TYPE_MAPPINGS } from "../../app/common/util/genericConstants";

class FieldWrapper extends Component {
  state = {};
  componentDidMount() {
    const name = this.props.name.includes(".")
      ? this.props.name.split(".")[1]
      : this.props.name;

    let func = this.fieldPermissions[name].autoGenerateFunc;
    func !== null && func();
  }

  render() {
    const {
      name: fieldDefinedName,
      placeholder,
      heading,
      component,
      type,
      disabled,
      mandatory,
      data,
      allowClear,
      labelInValue,
      showSearch,
      getSelectedValue,
      handleOnBlur,
      onChange,
      labelOne,
      valueOne,
      labelTwo,
      valueTwo,
      disableFunction,
      width,
      description,
      onFocus,
      validate,
      normalize,
      match: { params },
    } = this.props;

    let userType = getUserType();

    const name = fieldDefinedName.includes(".")
      ? fieldDefinedName.split(".")[1]
      : fieldDefinedName;

    const field = this.fieldPermissions[name];

    if (
      field.allowedView.includes(ORDER_TYPE_MAPPINGS[params.orderType]) ===
      false
    ) {
      //  console.log(fieldDefinedName, name);
      return null;
    }

    if (this.fieldPermissions[name].hiddenFor.includes(userType) === true) {
      return null;
    } else {
      if (type === "text") {
        return (
          <Col span={width}>
            {mandatory === true && <MandatoryHeader heading={heading} />}
            {mandatory === false && (
              <Header sub color="teal" content={heading} />
            )}
            <div style={{ display: "flex" }}>
              <div style={{ width: "100%" }}>
                <Field
                  disabled={
                    disabled ||
                    this.fieldPermissions[name].disabledFor.includes(
                      userType
                    ) === true
                  }
                  name={fieldDefinedName}
                  placeholder={placeholder}
                  component={component}
                  handleOnBlur={handleOnBlur}
                  validate={validate}
                  normalize={normalize}
                />
              </div>
              {this.fieldPermissions[name].tooltip.showFor.includes(
                userType
              ) === true && (
                <div style={{ padding: "3%" }}>
                  <Tooltip
                    overlayStyle={{ maxWidth: "100%" }}
                    title={this.fieldPermissions[name].tooltip.data}
                  >
                    <Icon type="question-circle" />
                  </Tooltip>
                </div>
              )}
            </div>

            {this.fieldPermissions[name].message.showFor.includes(userType) ===
              true && (
              <Label basic color="violet" style={{ marginTop: "10px" }}>
                {this.fieldPermissions[name].message.value}
              </Label>
            )}
            {description && (
              <Label basic color="blue" style={{ marginTop: "10px" }}>
                {description}
              </Label>
            )}
          </Col>
        );
      } else if (type === "select") {
        return (
          <Col span={width}>
            {mandatory === true && <MandatoryHeader heading={heading} />}
            {mandatory === false && (
              <Header sub color="teal" content={heading} />
            )}
            <div style={{ display: "flex" }}>
              <div style={{ width: "100%" }}>
                <Field
                  disabled={
                    disabled ||
                    this.fieldPermissions[name].disabledFor.includes(
                      userType
                    ) === true
                  }
                  type={type}
                  name={fieldDefinedName}
                  placeholder={placeholder}
                  component={component}
                  data={data}
                  allowClear={allowClear}
                  labelInValue={labelInValue}
                  showSearch={showSearch}
                  getSelectedValue={getSelectedValue}
                  onFocus={onFocus}
                  validate={validate}
                  normalize={normalize}
                />
              </div>
              {this.fieldPermissions[name].tooltip.showFor.includes(
                userType
              ) === true && (
                <div style={{ padding: "3%" }}>
                  <Tooltip
                    overlayStyle={{ maxWidth: "100%" }}
                    title={this.fieldPermissions[name].tooltip.data}
                  >
                    <Icon type="question-circle" />
                  </Tooltip>
                </div>
              )}
            </div>
            {this.fieldPermissions[name].message.showFor.includes(userType) ===
              true && (
              <Label basic color="violet" style={{ marginTop: "10px" }}>
                {this.fieldPermissions[name].message.value}
              </Label>
            )}
            {description && (
              <Label basic color="blue" style={{ marginTop: "10px" }}>
                {description}
              </Label>
            )}
          </Col>
        );
      } else if (type === "radio") {
        return (
          <Col span={width}>
            {mandatory === true && <MandatoryHeader heading={heading} />}
            {mandatory === false && (
              <Header sub color="teal" content={heading} />
            )}
            <div style={{ display: "flex" }}>
              <div style={{ width: "100%" }}>
                <Form.Group inline>
                  <Field
                    disabled={
                      disabled ||
                      this.fieldPermissions[name].disabledFor.includes(
                        userType
                      ) === true
                    }
                    type={type}
                    name={fieldDefinedName}
                    placeholder={placeholder}
                    component={component}
                    onChange={onChange}
                    label={labelOne}
                    value={valueOne}
                    normalize={normalize}
                  />
                  <Field
                    disabled={
                      disabled ||
                      this.fieldPermissions[name].disabledFor.includes(
                        userType
                      ) === true
                    }
                    type={type}
                    name={fieldDefinedName}
                    placeholder={placeholder}
                    component={component}
                    onChange={onChange}
                    label={labelTwo}
                    value={valueTwo}
                    normalize={normalize}
                  />
                </Form.Group>
              </div>
              {this.fieldPermissions[name].tooltip.showFor.includes(
                userType
              ) === true && (
                <div style={{ padding: "0 10%" }}>
                  <Tooltip
                    overlayStyle={{ maxWidth: "100%" }}
                    title={this.fieldPermissions[name].tooltip.data}
                  >
                    <Icon type="question-circle" />
                  </Tooltip>
                </div>
              )}
            </div>

            {this.fieldPermissions[name].message.showFor.includes(userType) ===
              true && (
              <Label basic color="violet" style={{ marginTop: "10px" }}>
                {this.fieldPermissions[name].message.value}
              </Label>
            )}
            {description && (
              <Label basic color="blue" style={{ marginTop: "10px" }}>
                {description}
              </Label>
            )}
          </Col>
        );
      } else if (type === "checkbox") {
        return (
          <Col span={width}>
            {mandatory === true && <MandatoryHeader heading={heading} />}
            {mandatory === false && (
              <Header sub color="teal" content={heading} />
            )}

            <div style={{ display: "flex" }}>
              <div style={{ width: "50%" }}>
                <Field
                  disabled={
                    disabled ||
                    this.fieldPermissions[name].disabledFor.includes(
                      userType
                    ) === true
                  }
                  type={type}
                  name={fieldDefinedName}
                  placeholder={placeholder}
                  component={component}
                  onChange={onChange}
                  normalize={normalize}
                />
              </div>
              {this.fieldPermissions[name].tooltip.showFor.includes(
                userType
              ) === true && (
                <div>
                  <Tooltip
                    overlayStyle={{ maxWidth: "100%" }}
                    title={this.fieldPermissions[name].tooltip.data}
                  >
                    <Icon type="question-circle" />
                  </Tooltip>
                </div>
              )}
            </div>

            {this.fieldPermissions[name].message.showFor.includes(userType) ===
              true && (
              <Label basic color="violet" style={{ marginTop: "10px" }}>
                {this.fieldPermissions[name].message.value}
              </Label>
            )}
            {description && (
              <Label basic color="blue" style={{ marginTop: "10px" }}>
                {description}
              </Label>
            )}
          </Col>
        );
      } else if (type === "date") {
        return (
          <Col span={width}>
            {mandatory === true && <MandatoryHeader heading={heading} />}
            {mandatory === false && (
              <Header sub color="teal" content={heading} />
            )}
            <div style={{ display: "flex" }}>
              <div style={{ width: "100%" }}>
                <Field
                  disabled={
                    disabled ||
                    this.fieldPermissions[name].disabledFor.includes(
                      userType
                    ) === true
                  }
                  name={fieldDefinedName}
                  placeholder={placeholder}
                  component={component}
                  disableFunction={disableFunction}
                  normalize={normalize}
                />
              </div>
              {this.fieldPermissions[name].tooltip.showFor.includes(
                userType
              ) === true && (
                <div style={{ padding: "3%" }}>
                  <Tooltip
                    overlayStyle={{ maxWidth: "100%" }}
                    title={this.fieldPermissions[name].tooltip.data}
                  >
                    <Icon type="question-circle" />
                  </Tooltip>
                </div>
              )}
            </div>

            {this.fieldPermissions[name].message.showFor.includes(userType) ===
              true && (
              <Label basic color="violet" style={{ marginTop: "10px" }}>
                {this.fieldPermissions[name].message.value}
              </Label>
            )}
            {description && (
              <Label basic color="blue" style={{ marginTop: "10px" }}>
                {description}
              </Label>
            )}
          </Col>
        );
      }
    }
  }
  fieldPermissions = {
    reference_id: {
      disabledFor: [],
      autoGenerated: true,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE", "STOCK_MULTI"],
    },
    customer: {
      disabledFor: [],
      autoGenerated: true,
      autoGenerateFunc: this.props.setCustomerDependencies,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE", "STOCK_MULTI"],
    },
    distributor: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE", "STOCK_MULTI"],
    },
    retailer: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE"],
    },
    product_group: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE", "STOCK_MULTI"],
    },
    patient: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE"],
    },
    external_order_id: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE", "STOCK_MULTI"],
    },
    received_by: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: ["Branch", "Customer"],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE"],
    },
    entered_by: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: ["Corporate"],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE"],
    },
    manufacturing_business_unit: {
      disabledFor: [],
      autoGenerated: true,
      autoGenerateFunc: null,
      // autoGenerateFunc: this.props.setInitialManufacturingLocation,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER"],
    },
    shipping_same_as_billing: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE", "STOCK_MULTI"],
    },
    shipping_address: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE", "STOCK_MULTI"],
    },

    received_date: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: ["Branch", "Customer"],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE", "STOCK_MULTI"],
    },

    dispatch_type: {
      disabledFor: ["Branch", "Customer"],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value:
          "To change shipping mode, please contact lab after entering order here",
        showFor: ["Branch", "Customer"],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE", "STOCK_MULTI"],
    },

    received_hour: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: ["Branch", "Customer"],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE", "STOCK_MULTI"],
    },
    received_minute: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: ["Branch", "Customer"],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE", "STOCK_MULTI"],
    },
    urgent: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: ["Customer"],
      tooltip: { data: tooltips.urgent, showFor: ["Branch"] },
      message: {
        value:
          "Please note that urgent orders can’t be accepted beyond certain timelines. Please refer to the information attached. If you still have any queries, contact customer care",
        showFor: ["Branch"],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE"],
    },
    stock_description: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["STOCK_SINGLE", "STOCK_MULTI"],
    },
    lnam: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: tooltips.lnam, showFor: ["Branch"] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE", "STOCK_MULTI"],
    },
    coating: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE", "STOCK_MULTI"],
    },
    corridor: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: tooltips.corridor, showFor: ["Branch", "Customer"] },
      message: {
        value:
          "For Prolux range, Corridor is not chosen, and so will take a value automatically",
        showFor: ["Branch", "Customer"],
      },
      allowedView: ["RX_ORDER"],
    },
    fitting_height: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: {
        data: tooltips.fitting_height,
        showFor: ["Branch", "Customer"],
      },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER"],
    },
    clinit: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER"],
    },
    promised_date: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE"],
    },
    promised_hour: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE"],
    },
    promised_minute: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE"],
    },
    cto: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: ["Branch", "Customer"],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER"],
    },
    sph: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE", "STOCK_MULTI"],
    },
    cyl: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE", "STOCK_MULTI"],
    },
    axis: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE", "STOCK_MULTI"],
    },
    add: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE", "STOCK_MULTI"],
    },
    dia: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER"],
    },
    ellh: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: ["Branch", "Customer"],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER"],
    },
    swing: {
      disabledFor: ["Branch", "Customer"],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: tooltips.swing, showFor: ["Branch", "Customer"] },
      message: {
        value:
          "If you want to change the swing, place that order with customer care",
        showFor: ["Branch", "Customer"],
      },
      allowedView: ["RX_ORDER"],
    },
    mbase: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: tooltips.mbase, showFor: ["Branch", "Customer"] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER"],
    },
    ct: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: tooltips.ct, showFor: ["Branch", "Customer"] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER"],
    },
    et: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: tooltips.et, showFor: ["Branch", "Customer"] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER"],
    },
    ed: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: ["Branch", "Customer"],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER"],
    },
    qty: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["STOCK_MULTI"],
    },
    mono_pd_r: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: tooltips.mono_pd_r, showFor: ["Branch", "Customer"] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER"],
    },
    mono_pd_l: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: tooltips.mono_pd_l, showFor: ["Branch", "Customer"] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER"],
    },
    npd_r: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: tooltips.npd_r, showFor: ["Branch", "Customer"] },
      message: {
        value: "This measurement is only needed when booking a Prolux Product",
        showFor: ["Branch", "Customer"],
      },
      allowedView: ["RX_ORDER"],
    },
    npd_l: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: tooltips.npd_l, showFor: ["Branch", "Customer"] },
      message: {
        value: "This measurement is only needed when booking a Prolux Product",
        showFor: ["Branch", "Customer"],
      },
      allowedView: ["RX_ORDER"],
    },
    frame_type: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: tooltips.frame_type, showFor: ["Branch", "Customer"] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE"],
    },
    a_width: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: tooltips.a_width, showFor: ["Branch", "Customer"] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE"],
    },
    b_width: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: tooltips.b_width, showFor: ["Branch", "Customer"] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE"],
    },
    dbl: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: tooltips.dbl, showFor: ["Branch", "Customer"] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE"],
    },
    panto: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: tooltips.panto, showFor: ["Branch", "Customer"] },
      message: {
        value: "This measurement is only needed when booking a Prolux Product",
        showFor: ["Branch", "Customer"],
      },
      allowedView: ["RX_ORDER"],
    },
    ztilt: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: tooltips.ztilt, showFor: ["Branch", "Customer"] },
      message: {
        value: "This measurement is only needed when booking a Prolux Product",
        showFor: ["Branch", "Customer"],
      },
      allowedView: ["RX_ORDER"],
    },
    bvd: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: tooltips.bvd, showFor: ["Branch", "Customer"] },
      message: {
        value: "This measurement is only needed when booking a Prolux Product",
        showFor: ["Branch", "Customer"],
      },
      allowedView: ["RX_ORDER"],
    },
    specification: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE"],
    },
    tint_needed: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: tooltips.tint, showFor: ["Branch", "Customer"] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE"],
    },
    tint: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: tooltips.tint, showFor: ["Branch", "Customer"] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE"],
    },
    fitting_received: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER", "STOCK_SINGLE"],
    },
    special_instructions: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value:
          "If you have any other requests or clarification about the order, please contact customer care.",
        showFor: ["Branch", "Customer"],
      },
      allowedView: ["RX_ORDER"],
    },
    tool_charges: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: ["Branch", "Customer"],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER"],
    },
    other_charges: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: ["Branch", "Customer"],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER"],
    },
    in_out: {
      disabledFor: [],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: ["Branch", "Customer"],
      tooltip: { data: null, showFor: [] },
      message: {
        value: null,
        showFor: [],
      },
      allowedView: ["RX_ORDER"],
    },
    prva1: {
      disabledFor: ["Branch", "Customer"],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value:
          "If your order has prism, please consult with Customer care directly",
        showFor: ["Branch", "Customer"],
      },
      allowedView: ["RX_ORDER"],
    },
    prva2: {
      disabledFor: ["Branch", "Customer"],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value:
          "If your order has prism, please consult with Customer care directly",
        showFor: ["Branch", "Customer"],
      },
      allowedView: ["RX_ORDER"],
    },
    prvm1: {
      disabledFor: ["Branch", "Customer"],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value:
          "If your order has prism, please consult with Customer care directly",
        showFor: ["Branch", "Customer"],
      },
      allowedView: ["RX_ORDER"],
    },
    prvm2: {
      disabledFor: ["Branch", "Customer"],
      autoGenerated: false,
      autoGenerateFunc: null,
      hiddenFor: [],
      tooltip: { data: null, showFor: [] },
      message: {
        value:
          "If your order has prism, please consult with Customer care directly",
        showFor: ["Branch", "Customer"],
      },
      allowedView: ["RX_ORDER"],
    },
  };
}
const actions = {
  setCustomerDependencies,
  setInitialManufacturingLocation,
};
const mapStateToProps = (state) => ({});
export default connect(
  mapStateToProps,
  actions
)(withRouter(FieldWrapper));
